<template>
  <!-- 分享下载页面 -->
  <div class="downWrap">
      <img class="img" src="../images/shareBg.png" alt="">
      <div class="btn" @click="toStore">下载慧殡葬APP</div>
      <v-downTip :popShow="popShow" ></v-downTip>
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      popShow:false,
    }
  },
  created(){
  },
  mounted(){
    weixin.shareInfo(13,'',this.$route.query.accountId)
    weixin.shareTitle(13,'12',(data)=>{
      this.shareSwiper = data;
    });
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    }
  }
}
</script>

<style scoped lang="less">
.downWrap{
  position: relative;
  .img{
    width: 100%;
    // height: 800px;
    margin-bottom: 80px;
  }
  .btn{
    position: absolute;
    left: 50%;
    margin-left: -280px;
    text-align: center;
    width: 560px;
    height: 88px;
    line-height: 88px;
    font-size: 30px;
    color: #FFFFFF;
    background-image: linear-gradient(90deg, #EF4B4B 0%, #F7643C 100%);
    box-shadow: 4px 8px 20px 0 rgba(239,75,75,0.27);
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/share/sharedown.vue